module.exports = __webpack_public_path__ + "img/b3.a379273d.png";